import React, {Component} from 'react'
import {combineReducers} from 'redux'
import {LOCATION_CHANGE, push as pushAction, replace as replaceAction} from 'react-router-redux'

const NAMESPACE = 'Core'
export const HISTORY_CLEARED = NAMESPACE + '/HistoryCleared'
export const GONE_BACK = NAMESPACE + '/GoneBack'

// actions

export function goBack() {
    return (state) => {
        const {history, back} = state.router

        if (back) {
            window.location = back
            return {
                type: GONE_BACK
            }
        }
        return replaceAction(state.router.history[1] || '/')
    }
}

export function push(nextPathname) {
    return (state) => {
        const {location} = state.router
        const pathnameSegments = location.pathname.split('/').slice(1)

        nextPathname = nextPathname.replace(/^\/\*/, '/' + pathnameSegments[0])
        nextPathname = nextPathname.replace(/^(\/[\w-]+)\/\*/, '$1/' + pathnameSegments[1])
        nextPathname = nextPathname.replace(/^(\/[\w-]+\/[\w-]+)\/\*/, '$1/' + pathnameSegments[2])
        return pushAction(nextPathname)
    }
}

export function clearHistory() {
    return {
        type: HISTORY_CLEARED
    }
}

// reducers

function locationBeforeTransitions(state = null, action) {
    switch (action.type) {
        case LOCATION_CHANGE:
            return action.payload
        default:
            return state
    }
}

function location(state = null, action) {
    switch (action.type) {
        case LOCATION_CHANGE:
            return action.payload
        default:
            return state
    }
}

function history(state = [], action) {
    switch (action.type) {
        case LOCATION_CHANGE:
            const nextLocation = action.payload

            if (nextLocation.action == 'REPLACE') {
                // replace location
                if (nextLocation.pathname == (state[1] && state[1].pathname)) return [nextLocation]
                return [nextLocation, state[1]]
            }

            if (nextLocation.action == 'POP') {
                // replace location
                return [nextLocation, state[0]]
            }

            if (nextLocation.pathname == (state[0] && state[0].pathname)) {
                // replace location
                return [nextLocation, state[1]]
            }

            // push location
            return [nextLocation, state[0]]
        case HISTORY_CLEARED:
            return [state[0]]
        default:
            return state
    }
}

function back(state = null) {
    return state
}

export const routeReducer = combineReducers({locationBeforeTransitions, location, history, back})

// higher order component

export function connectLocationChangeLock(option = {}) {
    return (WrappedComponent) => {

        class LocationChangeLockConnector extends Component {

            constructor(props) {
                super(props)

                this.state = {
                    locationChanged: false
                }
            }

            componentWillReceiveProps(nextProps) {
                if (nextProps.location != this.props.location) {
                    const {location} = nextProps

                    const locationChanged = !option.pathName || location.pathname.match(option.pathName) == null
                    this.setState({locationChanged})
                }
            }

            shouldComponentUpdate(nextProps, nextState) {
                return !nextState.locationChanged
            }

            render() {
                return <WrappedComponent {...this.props} />
            }
        }

        return LocationChangeLockConnector
    }
}


// WEBPACK FOOTER //
// ./lib/core/redux/router.js